<app-stages [stages]="stages" currentStage="Wykaz przystanków">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <app-bus-stops-preview
    [canEdit]="!showItemForm"
    [expanded]="false"
    (onEdit)="showItemForm = true; form.patchValue($event.v); currentIndex = $event.i"
    (onRemove)="onRemoveItem($event)"
    [showActions]="true"
    [listOfStops]="listOfStops()">
  </app-bus-stops-preview>
  @if (showItemForm) {
    <br>
    <app-bus-stop-item-form
      [showCancel]="!!listOfStops().length"
      [edit]="currentIndex != undefined"
      (submit)="onSubmitItemForm($event)"
      (cancel)="showItemForm = false"
      [form]="form">
    </app-bus-stop-item-form>
  }
  @if (!showItemForm) {
    <br>
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-primary" type="button" (click)="showItemForm = true">
          {{ listOfStops().length ? 'Dodaj kolejny' : 'Dodaj przystanek' }}
        </button>
      </div>
    </div>
    <br>
  }
  <div class='application-actions'>
    <button
      [disabled]="pending()"
      (click)="onCancel()"
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      [disabled]="pending()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
